import {
  Card,
  Unlimited,
  Visits
} from '@com-delta-idp/mnx-skymiles-overview-ui';
import { getImage } from '@com-delta-idp/mnx-skymiles-shared';
import { Image } from '@com-delta-idp/mnx-ui-kit';
import { CardTile, SkyClub, VisitRecord } from '../models';

export const getSkyClubDescription = (
  aem: SkyClub,
  card: VisitRecord
): string => {
  const visitsLeft = getVisitsLeft(card);
  if (visitsLeft > 4) {
    return getScaleDescription(aem, 'HIGH');
  } else if (visitsLeft === 0) {
    return getScaleDescription(aem, 'ZERO');
  } else {
    return getScaleDescription(aem, 'LOW');
  }
};

export const getScaleDescription = (
  aem: SkyClub,
  scaleType: string
): string => {
  let description = '';
  for (const scale of aem.visitScale) {
    if (scale.type.toUpperCase() === scaleType.toUpperCase()) {
      description = scale.desc;
    }
  }
  return description;
};

export const getVisitsLeft = (card: VisitRecord): number => {
  return card.annualVisitAllotment - card.visitsUsed;
};

export const getVisitsObject = (aem: SkyClub, card: VisitRecord): Visits => {
  return {
    min: getVisitsLeft(card).toString(),
    ofLabel: aem.ofLabel,
    max: card.annualVisitAllotment.toString(),
    scale: card.visitScaleInd,
    label: aem.tooltipLabel,
    tooltipInfo: aem.tooltipInfo
  };
};

export const getUnlimited = (aem: SkyClub, card: VisitRecord): Unlimited => {
  return {
    unlocked: card.thresholdMetInd,
    membership: false,
    image: getImage(aem.unlimited.imgSrc, aem.unlimited.imgAlt),
    title: aem.unlimited.cardDesc,
    subtitle: aem.unlimited.cardValidity, //TODO: Make this as dynamic -> POST MVP
    terms: {
      label: aem.unlimited.cardTCLabel,
      url: aem.unlimited.cardTCLink,
      id: aem.unlimited.cardTCId
    },
    skyclub: {
      label: 'Plan to visit a Delta Sky Club for your next trip.',
      eligible: {
        id: 'eligibleSkyclub',
        label: 'Search for Eligible Delta Sky Clubs',
        url: ''
      }
    }
  };
};

export const getImageData = (
  aemCardTiles: CardTile[],
  typeCode: string
): Image | undefined => {
  const tile: CardTile | undefined = aemCardTiles.find(
    (cardTile) => cardTile.type === typeCode
  );
  return tile ? getImage(tile.imageSrc, tile.imageAlt) : undefined;
};

export const compareMembership = (cardA: Card, cardB: Card): number => {
  return cardA.unlimited.membership === cardB.unlimited.membership
    ? 0
    : cardA.unlimited.membership
      ? -1
      : 1;
};

export const compareUnlocked = (cardA: Card, cardB: Card): number => {
  return cardA.unlimited.unlocked === cardB.unlimited.unlocked
    ? 0
    : cardA.unlimited.unlocked
      ? -1
      : 1;
};

export const compareVisits = (cardA: Card, cardB: Card): number => {
  const visits1 = cardA.visits?.min ?? -1;
  const visits2 = cardB.visits?.min ?? -1;
  return +visits1 - +visits2;
};

export const sortedData = (cards: Card[]): Card[] => {
  return cards.sort((cardA, cardB) => {
    let result = compareMembership(cardA, cardB);
    if (result !== 0) return result;

    result = compareUnlocked(cardA, cardB);
    if (result !== 0) return result;

    return compareVisits(cardA, cardB);
  });
};
